/**
 * Small signals that decide when the upgrade/welcome modal is allowed to
 * appear. Kept deliberately conservative so prompts never feel aggressive:
 * the welcome modal shows once after account creation, and the out-of-credits
 * prompt shows at most once per browser session.
 */
const WELCOME_FLAG = 'toxicdetector.welcome_modal_pending'
const NO_CREDITS_FLAG = 'toxicdetector.no_credits_prompted'
export function markWelcomeModalPending(): void {
  try {
    window.localStorage.setItem(WELCOME_FLAG, '1')
  } catch {
    /* no-op */
  }
}
/** Returns true once, then clears the flag. */
export function consumeWelcomeModalPending(): boolean {
  try {
    if (window.localStorage.getItem(WELCOME_FLAG) !== '1') return false
    window.localStorage.removeItem(WELCOME_FLAG)
    return true
  } catch {
    return false
  }
}
/** Returns true at most once per session. */
export function consumeNoCreditsPrompt(): boolean {
  try {
    if (window.sessionStorage.getItem(NO_CREDITS_FLAG) === '1') return false
    window.sessionStorage.setItem(NO_CREDITS_FLAG, '1')
    return true
  } catch {
    return false
  }
}
